<template>
  <v-app class="d-flex flex-column">
    <Navbar />
    
    <Alert v-show="isLoggedIn && noRatingScreen" />

    <v-content class="no-pd-t">
      <router-view v-if="currentCompanyExists" />
    </v-content>

    <div class="margin-top-divider-30" v-if="actualRoute != 'senha'"/>

    <Footer v-if="actualRoute != 'senha'"/>
  </v-app>
</template>

<script>
import EVENT_BUS from "@/domain/event-bus/eventBus";

//Store
import { mapActions, mapGetters } from "vuex";

//Services
import { getInfoBySubdomain } from "@/app/shared-components/navbar/service/navbar.service";
import { 
    getPushSubscriptionByCurrentIdAndCompanyId,
    getPushNotificationsByCurrentContactIdAndCompanyId
} from "@/support/push-notification/push-notification.service"
import { updateLocationByCurrentId } from "@/support/geolocation/geolocation.service";

//Components
import Navbar from '@/app/shared-components/navbar/navbar';
import Footer from "@/app/shared-components/footer/footer";
import Alert from "@/app/shared-components/alert/alert.vue";

export default {
  name: 'App',
  components: { Navbar, Footer, Alert },
  data: () => ({
    showAlertControl: false,
    currentCompanyExists: false,
    noRatingScreen: true,
    callNotificationId: null,
    browserHasSupportedModel: null
  }),
  computed: {
    ...mapGetters('authenticateStore', {
        companyImage: 'get_currentCompanyImage',
        isLoggedIn: 'isLoggedIn'
      }
    ),
    ...mapGetters('routeStore', {
        actualRoute : 'get_actualRoute'
      }
    ),
    ...mapGetters('authenticateStore', {
        currentCompany: 'get_currentCompany'
      }
    ),
    ...mapGetters('pushNotificationStore', {
      wantNotifications: 'get_wantNotification'
    }),
    ...mapGetters('pushNotificationStore', {
      browserHasSupported: 'get_browserHasSupported'
    }),
    ...mapGetters('pushNotificationStore', {
      changeRotine: 'get_changeRotine'
    })
  },
  watch: {
    actualRoute: {
      deep: true,
      immediate: true,
      handler() {
        (this.actualRoute.startsWith('avaliacao') )? this.noRatingScreen = false : this.noRatingScreen = true
      }
    },
    changeRotine: {
      deep: false,
      handler() {
        if(this.changeRotine && this.browserHasSupported) { //Começar rotina de pushNotification
          this.setBrowserHasSupported()
        }
        if(!this.changeRotine && this.browserHasSupported) { //Desligar rotina de pushNotification
          clearInterval(this.callNotificationId)
        } 
      }
    },
    isLoggedIn: {
      immediate: true,
      handler() {
        if(this.isLoggedIn) { //Se estiver logado
          this.getLocation()//Get geolocation
          this.setBrowserHasSupported() //start pushNotifications
        } else {
          clearInterval(this.callNotificationId)
        }
      }
    }
  },
  created() {
    this.setPrimaryAndSecondaryColors()
    this.setDynamicNameAndImageOfProject()
    EVENT_BUS.$on('ToastNotification', notificationObject => {
        this.$toasted.show(notificationObject.message, { type: `${notificationObject.type}`})
      }
    )
    this.getCurrentCompany()
  },
  methods: {
    ...mapActions('authenticateStore', ['SET_CURRENT_COMPANY']),
    setPrimaryAndSecondaryColors() {
      document.documentElement.style.setProperty('--cor--primaria', this.currentCompany.primary)
      document.documentElement.style.setProperty('--cor--secundaria', this.currentCompany.buttonsColor)
    },
    setDynamicNameAndImageOfProject() {
      if (window.location.host.endsWith(".lity.com.br")) {
        document.title = window.location.host.split(".")[0]
      } else {
        document.title = window.location.host
      }
    },
    ...mapActions('pushNotificationStore', ['SET_LOCAL_WANT_NOTIFICATION']),
    ...mapActions('pushNotificationStore',['SET_LOCAL_BROWSER_HAS_SUPPORTED']),
    getCurrentCompany() {
      getInfoBySubdomain()
        .then( success => {
                this.SET_CURRENT_COMPANY(success.data)
                this.setAndModifyTabInfo(success.data.image, success.data.name)
                this.currentCompanyExists = true
              }
          )
          .catch( error => {
                  if (error != null) {
                    this.$toasted.show(error.message, { type: 'error' } )
                  }
              }
          )
    },
    setAndModifyTabInfo( image, name ) {
      let iconSelectors = document.querySelectorAll("link[rel*='icon']")
      iconSelectors.forEach(element => {
          element.href = image
        }
      )

      var ogImage = document.getElementById("ogImage")
      ogImage.name = "ogImage"
      ogImage.setAttribute('property', 'og:image')
      ogImage.content = image

      document.querySelector("meta[name*='apple-mobile-web-app-title']").content = name
      window.document.title = name

      var ogTitle = document.getElementById("ogTitle")
      ogTitle.name = "ogTitle"
      ogTitle.setAttribute('property', 'og:title')
      ogTitle.content = name

      var ogSiteTitle = document.getElementById("ogSiteName")
      ogSiteTitle.name = "ogSiteName"
      ogSiteTitle.setAttribute('property', 'og:site_name')
      ogSiteTitle.content = name

      var ogDescription = document.getElementById("ogDescription")
      ogDescription.name = "ogDescription"
      ogDescription.setAttribute('property', 'og:description')
      ogDescription.content = "Faça o seu cadastro e receba os melhores benefícios"
    },
    //Push notification
    setBrowserHasSupported() { //registra service-worker, seta controle de suporte e começa a rotina de pushNotification
      if( 'Notification' in window && 'serviceWorker' in navigator ) {
        this.SET_LOCAL_BROWSER_HAS_SUPPORTED(true);
        this.browserHasSupportedModel = this.browserHasSupported;
        this.getSituationPushNotification();
      }      
    },
    getSituationPushNotification() {//Pegar controle de wantNotifications
      if( this.browserHasSupportedModel && this.isLoggedIn ) { 
        getPushSubscriptionByCurrentIdAndCompanyId( this.currentCompany.id ) 
        .then( success => {
            this.SET_LOCAL_WANT_NOTIFICATION(success.data.enabled)
            if(this.wantNotifications) this.askPermission();
          }
        )
        .catch( error => {
            if (error != null) {
              this.$toasted.show(error.message, { type: 'error' } )
            }
          }
        )
      }
    },
    askPermission() {//Pede permissão para exibir notifications
      if( this.browserHasSupportedModel ) {
        Notification.requestPermission()
        .then( notificationResponse => {
            if( notificationResponse !== 'granted' ) {
              alert('Notificações bloqueadas - Ative as notificações para receber todas as novidades preparadas para você.')
             }else {
                this.callListNotification()
            }
          } 
        )
      }
    },
    callListNotification() { //captura lista pushNotification a cada 1m
      this.callNotificationId = setInterval(() => {
        this.getListPushNotification()
      }, 60000);
    },
    getListPushNotification() {//recebe um array de objetos 'pushNotification'
      getPushNotificationsByCurrentContactIdAndCompanyId( this.currentCompany.id )
      .then( success => {
          this.sendPushNotifications(success.data)
        }
      )
      .catch( error => {
          if (error != null) {
            this.$toasted.show(error.message, { type: 'error' } )
          }
        }
      )
    },
    sendPushNotifications(data) {//gera disparo de objeto 'pushNotification'
      if( data.length > 0 ) {
        data.forEach(element => { 
          this.showNotification(element)
        })
      }
    },
    showNotification(dataObject) {//Registra no trabalhador service-work uma mensagem pushNotification
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready // returns a Promise, the active SW registration
          .then(swreg => swreg.showNotification(dataObject.title, {
              body: dataObject.body,
              icon: dataObject.icon,
              image: dataObject.image,
              vibrate: [300, 200, 300],
              badge: dataObject.icon,
              // actions: [
              //     { action: 'confirm', title: 'Okay'},
              //     { action: 'cancel', title: 'Cancel'}
              // ],
          }
        ))
      }  
    },
    //====
    //Geolocation
    getLocation() { //Solicitação ao usuário permissão e automaticamente pega-la
      if(navigator.geolocation) { //verificando suporte/API geolocation
        navigator.geolocation.getCurrentPosition( position => {
          var location = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          }
          this.setContactLocation(location)
        })
      }
    },
    setContactLocation(currentLocation) {
      updateLocationByCurrentId(currentLocation)
        .then( )
        .catch( error => {
            if (error != null) {
              this.$toasted.show(error.message, { type: 'error' } )
            }
          }
        )
    }
    //==
  }
};
</script>

<style>
/* ################################################################################################## */
/* ################################################################################################## */
/* ################################################################################################## */

/*-----------------------------------------------------------------------------------

	Description: Classes globais Lity Tecnologia - Cative
  Author: Igor Saramago Mendonça - Líder Front-end
	Version: 1.0

-----------------------------------------------------------------------------------*/
/*============================== Classes gerais ==============================*/

#app {
  font-family: 'Nunito', sans-serif;
}
.v-dialog > .v-card > .v-card__subtitle {
  padding: 20px 24px !important;
}

.row {
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.v-application p {
    margin-bottom: 0px !important;
}

.pointer {
  cursor: pointer;
}

/*============================== Classes específicas ==============================*/
.max-container {
  max-width: 1185px !important;
}
/*============================== CLASSES PARA DEV ==============================*/
.red-border {
  border: 2px solid red !important;
}

/*============================== Toasted ==============================*/
.toast {
  font-family: 'Nunito', sans-serif;
  font-size: 16px !important;
  padding: 10px 5px 10px 25px !important;
}

/*============================== Flex classes ==============================*/
.flex-row-center {
  display: flex;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: center !important;
  flex: auto !important;
}
.flex-row-start {
  display: flex;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: start !important;
  flex: auto !important;
}
.flex-row-space-around {
  display: flex;
  flex-direction: row !important;
  align-items: baseline !important;
  justify-content: space-around !important;
  flex: auto !important;
}
.flex-row-center-space-around {
  display: flex;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: space-around !important;
  flex: auto !important;
}
.flex-row-center-space-between {
  display: flex;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: space-between !important;
  flex: auto !important;
}
.flex-row-space-between {
  display: flex;
  flex-direction: row !important;
  justify-content: space-between !important;
  flex: auto !important;
}
.flex-row-baseline {
  display: flex;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: baseline !important;
  flex: auto !important;
}
.flex-row-end {
  display: flex;
  flex-direction: row !important;
  justify-content: flex-end !important;
  align-items: center !important;
  flex: auto !important;
}
.flex-row-end-start {
  display: flex;
  flex-direction: row !important;
  justify-content: flex-end !important;
  align-items: start !important;
  flex: auto !important;
}

.flex-col-center {
  display: flex;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  flex: auto !important;
}
.flex-col-start {
  display: flex;
  flex-direction: column !important;
  align-items: flex-start !important;
  justify-content: center !important;
  flex: auto !important;
}
.flex-col-start-start {
  display: flex;
  flex-direction: column !important;
  align-items: flex-start !important;
  justify-content: start !important;
  flex: auto !important;
}
.flex-col-space-between {
  display: flex;
  flex-direction: column !important;
  align-items: flex-start !important;
  justify-content: space-between !important;
  flex: auto !important;
}
.flex-col-center-inherit {
  display: flex;
  flex-direction: column !important;
  align-items: inherit !important;
  justify-content: center !important;
  flex: auto !important;
}
.flex-col-end {
  display: flex;
  flex-direction: column !important;
  align-items: flex-end !important;
  justify-content: center !important;
  flex: auto !important;
}
/*============================== Classes modal ==============================*/
.modal__container__div--Btn {
    display: flex;
    flex: auto;
    justify-content: flex-end;
    position: absolute;
    right: 22px;
    top: 16px;
}
.modal__container__btn__close {
    padding: 0px !important;
    height: 22px !important;
    width: 18.31px !important;
    min-width: 18.31px !important;
}
.modal__container__btn__close--span {
    font-size: 16px;
    width: 100%;
    height: 100%;
}
.modalSettings {
  max-height: 600px !important;
}
.modal__container {
    padding: 20px !important;
}
.modal__container__div--Btn {
    display: flex !important;
    flex: auto;
    justify-content: flex-end;
    position: absolute;
    right: 22px;
    top: 26px;
}
.modal__container__btn__close {
    padding: 0px !important;
    height: 22px !important;
    width: 18.31px !important;
    min-width: 18.31px !important;
    color: #9C22FC ;
}
.modal__container__btn__close--span {
    font-size: 16px;
    color: #9C22FC;
    width: 100%;
    height: 100%;
}
.modal__container__cardtitle {
  font-size: 21px !important;
  font-weight: 800 !important;
  color: #171717 !important;
  padding: 0px 0px 16px 0px !important;
}
.modal__container__cardtext--pd {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
/*============================== Text ==============================*/
.text-inherit {
  text-transform: inherit !important;
}
.text-none {
  text-transform: initial !important;
}
.text-end {
  display: flex;
  flex: auto !important;
  justify-content: flex-end;
}
.text-bold { 
  font-weight: bold !important;
}
.text-white {
  color: var(--cor--branco) !important;
}
.text-black {
  color: var(--cor--preta) !important;
}
.text-blue {
  color: var(--cor--azul) !important;
}

/*============================== Font ==============================*/
.font-bold {
  font-weight: bold !important;
}

/*============================== Width ==============================*/
.w-100 {
  width: 100% !important;
}
.w-90 {
  width: 90% !important;
}
.w-80 {
  width: 80% !important;
}
.w-60 {
  width: 60% !important;
}
.w-50 {
  width: 50% !important;
}
.w-40 {
  width: 40% !important;
}
.w-100-vh {
  width: 100vh !important;
}

/*============================== Height ==============================*/
.h-100 {
  height: 100% !important;
}
.h-100-vh {
  height: 100vh !important;
}

/*============================== Margin ==============================*/
.margin-top-divider-60 {
  margin-top: 60px;
}
.margin-bt-divider-60 {
  margin-bottom: 60px;
}
.margin-top-divider-30 {
  margin-top: 30px;
}
.margin-bt-divider-30 {
  margin-bottom: 30px;
}
.no-mg {
  margin: 0px !important;
}
.no-mg-b {
  margin-bottom: 0px !important;
}
/*============================== Padding ==============================*/
.no-pd {
  padding: 0 !important;
}
.no-pd-t {
  padding-top: 0 !important;
}
.no-pd-b {
    padding-bottom: 0px !important;
}
.no-pd-l {
  padding-left: 0 !important;
}
.no-pd-r {
    padding-right: 0px !important;
}

/*============================== Buttons ==============================*/
.custom-btn  {
  border-radius: 32px !important;
  padding: 0px 16px !important;
}
.principal__button {
  padding: 14px 120px 14px 120px !important;
  border-radius: 5px;
}
.btn__text-icon {
  margin-left: 6px;
}
.btn--left {
  margin-left: 26px !important;
}

/*============================== Colors Lity  ==============================*/
:root {
  --cor--preta: #1E1E1E;
  --cor--cinza: #C9C9C9;
  --cor--cinza--escuro: #898989;
  --cor--cinzaApp: #A9A9A9;
  --cor--roxo: #9C22FC;
  --cor--roza: #ED1B7A;
  --cor--azul: #06B6ED;
  --cor--azul--escuro: #190099;
  --cor--verde: #03E080;
  --cor--amarelo: #FFD202;
  --cor--branco: #FFFFFF;
  --cor--facebook: #3B5998;
  --cor--laranja: #EE5D09;
  --cor--primaria: #000000;
  --cor--secundaria: #000000;
}

/*============================== Card ==============================*/
.card__border-radius {
  border-radius: 14px !important;
}
.custom-card {
  margin: 30px 8px 0px 8px;
}
.custom-card__title {
  font-size: 18px;
  color: var(--cor--preta);
  word-break: break-word !important;
  font-weight: bold;
  line-height: initial;
}
.custom-card__description {
  font-size: 16px;
  color: var(--cor--preta);
  word-break: break-word;
  max-height: 90px;
  min-height: 90px;
  overflow: auto;
}
.custom-card .v-btn {
  border-radius: 32px !important;
  color: var(--cor--branco);
  padding: 0px 14px !important;
  font-weight: bold;
}
.card__action__pd-bottom {
  padding-bottom: 16px !important;
}
.card__text__pd-bottom {
  padding-bottom: 8px !important;
}

/*==-------- Modifiers --------==*/
.expiring--card {
  border: 1px solid var(--cor--roza) !important;
}
.expiring--card .v-btn {
  background-color: var(--cor--roza) !important;
}
/* ################################################################################################## */
/* ################################################################################################## */
/* ################################################################################################## */

</style>
